<template>
  <div>
    <my-upload ref="editor" v-if="col.editor.upload" :uploadtype="col.editor.uploadtype||'img'" @uploadsuccess="onAfterEdit" v-model="props.row[modelfield]"
               :showtips="false"></my-upload>
    <a v-else-if="col.editor.jumper"
       style="cursor:pointer;"
       @click="col.editor.jumpto(col.field,props.row,props.$index)"
       v-text="isFunction(col.editor.text)?col.editor.text(props.row):props.row[modelfield]"
    />
    <template
      v-else-if="col.editor.editabled?col.editor.editabled(props.$index,props.row):true"
    >
      <slot v-if="!editing">
        <el-button type="text" icon="el-icon-edit" style="line-height:2;white-space:normal;min-width:fit-content" @click="onBeginEdit">
          <slot v-if="isEmpty(props.row[modelfield])">编辑</slot>
          <slot v-else-if="col.editor.render">
            <div style="display: inline-block"
                 v-html="col.editor.render(props.$index,props.row)"></div>
          </slot>
          <slot v-else-if="col.editor.convert">
            <span style="display: inline-block"
                  v-text="getFieldVal(col.editor.convert.obj, getFieldVal(props.row, col.editor.convert.path || col.field), col.editor.convert.def || '')"></span>
          </slot>
          <slot v-else-if="col.editor.localselect">
            <div style="display: inline-block" v-text="renderSel()"></div>
          </slot>
          <slot v-else-if="col.editor.remoteselect">
            <div style="display: inline-block" v-text="renderSel()"></div>
          </slot>
          <slot v-else>{{ props.row[modelfield] }}</slot>
        </el-button>
      </slot>
      <slot v-if="editing">
        <el-input v-if="col.editor.input"
                  ref="editor"
                  :maxlength="col.editor.maxlength||2000"
                  v-model="props.row[modelfield]"
                  :disabled="col.editor.disabled?col.editor.disabled(props.$index,props.row):false"
                  @blur="onAfterEdit(col.field,props.row,props,$event)"
        ></el-input>
        <el-input-number
          v-if="col.editor.number"
          ref="editor"
          v-model="props.row[modelfield]"
          :precision="col.editor.pre==0?0:col.editor.pre||0"
          :min="col.editor.min||0"
          :max="col.editor.max||Number.MAX_VALUE"
          :step="col.editor.step||1"
          controls-position="right"
          :disabled="col.editor.disabled?col.editor.disabled(props.$index,props.row):false"
          @blur="onEditorBlur(col.field,props.row,props,$event)"
        ></el-input-number>
        <el-date-picker v-if="col.editor.editdate"
                        ref="editor"
                        v-model="props.row[modelfield]"
                        style="width:100%"
                        :type="col.editor.type" :value-format="col.editor.format"
                        placeholder="选择日期" align="right"
                        :disabled="col.editor.disabled?col.editor.disabled(props.$index,props.row):false"
                        @blur="onAfterEdit(col.field,props.row,props,$event)"
                        @change="onAfterEdit(col.field,props.row,props,$event)"
        ></el-date-picker>
        <el-select
          ref="editor"
          v-if="col.editor.localselect&&col.editor.multiple"
          v-model="props.row[modelfield]"
          multiple
          @blur="onEditorBlur($event)"
          :disabled="col.editor.disabled?col.editor.disabled(props.$index,props.row):false"
        >
          <el-option
            v-for="(selopt,selidx) in col.editor.data"
            :label="selopt[col.editor.displayField]"
            :value="selopt[col.editor.valueField]"
            :disabled="col.editor.optdisabled?col.editor.optdisabled(selopt,props.row):false"
            :key="selidx"></el-option>
        </el-select>
        <el-select
          ref="editor"
          v-if="col.editor.localselect&&!col.editor.multiple"
          v-model="props.row[modelfield]"
          :disabled="col.editor.disabled?col.editor.disabled(props.$index,props.row):false"
          @blur="onEditorBlur($event)"
          @change="onAfterEdit(col.field,props.row,props,$event)"
        >
          <el-option
            v-for="(selopt,selidx) in col.editor.data"
            :label="selopt[col.editor.displayField]"
            :value="selopt[col.editor.valueField]"
            :key="selidx"></el-option>
        </el-select>
        <el-select
          ref="editor"
          v-if="col.editor.remoteselect"
          v-model="props.row[modelfield]"
          :remote-method="getRemoteSelectSearchMethod()"
          filterable
          remote
          reserve-keyword
          :disabled="col.editor.disabled?col.editor.disabled(props.$index,props.row):false"
          :popper-append-to-body="true"
          placeholder="请输入关键词"
          @blur="onEditorBlur($event)"
          @change="onAfterEdit(col.field,props.row,props,$event)"
        >
          <el-option
            v-for="(selopt,selidx) in props.row[col.editor.datafield]"
            :label="selopt[col.editor.displayField]"
            :value="selopt[col.editor.valueField]"
            :key="selidx"
          >
          </el-option>
        </el-select>
      </slot>
    </template>
    <template v-else>
      <slot v-if="col.editor.render">
        <div
          style="display: inline-block"
          v-html="col.editor.render(props.$index,props.row)"></div>
      </slot>
      <slot v-else-if="col.editor.convert">
        <span style="display: inline-block"
              v-text="getFieldVal(col.editor.convert.obj, getFieldVal(props.row, col.editor.convert.path || modelfield), col.editor.convert.def || '')"></span>
      </slot>
      <slot v-else-if="col.editor.localselect">
        <div style="display: inline-block" v-text="renderSel()"></div>
      </slot>
      <slot v-else-if="col.editor.remoteselect">
        <div style="display: inline-block" v-text="renderSel()"></div>
      </slot>
      <slot v-else>{{ props.row[modelfield] }}</slot>
    </template>
  </div>
</template>
<script>
  import $ from "jquery";
  import Vue from "vue";
  export default {
    name: 'MyCellEditor',
    props: ['col', 'onchange', 'cols', 'scope', 'props', 'fromvue'],
    data(){
//      this.props.row._rawrow=$.extend(true, {}, this.props.row);
      this.initModelField();
      return {
        modelfield: this.getModelField(),
        emptyattr: '',
        editing: false,
        //下拉框只有监听input的blur和change才方便控制是否显示编辑框
//        然而，当点击下拉项时就已经会触发blur事件了，此时若设editing为false，则下拉框都没了，此时也不会触发change事件了
//      若监听el-optin点击事件，则由于element没有click事件处理，只能监听原生的事件，然而又因为那个事件是冒泡的，是element
//        先处理才到自定义的处理，此时已经来不及了
        stillshow: false,
        prevalue: ''
      };
    },
    mounted: function () {
      var editor = this.col.editor;
      var editpath = editor.editpath;
      if (editpath) {
        this.$watch('props.row.' + this.modelfield, (newVal, oldVal) => {
          var a = 3;
          this.setVueFieldVal(this.props.row, editpath, newVal);
        });
        this.$watch('props.row.' + editpath, (newVal, oldVal) => {
          var a = 3;
          this.setVueFieldVal(this.props.row, this.modelfield, newVal);
        });
      }
    },
    methods: {
      setVueFieldVal(obj, path, val, create) {
        if (!obj || path == undefined) {
          return obj;
        }
        var pointer = obj, arrpath = String(path) ? String(path).split('.') : [];
        for (var i = 0; i < arrpath.length; i++) {
          var obj1 = arrpath[i];
          if (i == arrpath.length - 1) {
            this.$set(pointer, obj1, val);
          } else {
            if (pointer.hasOwnProperty(obj1)) {
              pointer = pointer[obj1];
            } else if (create) {
              this.$set(pointer, obj1, {});
              pointer = pointer[obj1];
            } else {
              return obj;
            }
          }
        }
        return pointer;
      },
      initModelField(){
        var row = this.props.row;
        var editor = this.col.editor;
        var editpath = editor.editpath;
        var modelfield = this.getModelField();
        if (editpath) {
          var check = this.hasField(this.props.row, editpath);
          if (check == false) {
            this.setVueFieldVal(row, editpath, '', true);
          }
          this.$set(this.props.row, modelfield, this.getFieldVal(row, editpath));
        }
      },
      getModelField(){
        var editor = this.col.editor;
        var editpath = editor.editpath;
        if (editpath) {
          return editpath.replace('.', '_');
        } else {
          return this.col.field;
        }
      },
      isEmpty(val){
        return $.isEmpty(val);
      },
      onBeginEdit(){
        var editor = this.col.editor;
        this.refreshPrevalue();
        var _this = this;
        this.getVue('layoutvue').$on('closedropdown', (ev, b, c) => {
          if (editor.localselect || editor.remoteselect) {
            if (editor.multiple) {
              var $el = $(ev.target);
              if (_this.stillshow && !($el.parents('.el-button').length)) {
                _this.onAfterEdit();
              }
            } else {
              if (_this.stillshow) {
                _this.editing = false;
                _this.stillshow = false;
              }
            }
          }
          if (editor.number) {
            var $el = $(ev.target);
            if (_this.stillshow && !($el.hasClass('el-icon-arrow-up') || $el.hasClass('el-icon-arrow-down'))) {
              _this.onAfterEdit();
            }
          }
        });
        this.editing = true;
        this.$nextTick(function () {
          this.$refs['editor'].focus();
        });
      },
      refreshPrevalue(){
        var field = this.getModelField();
        var rowdata = this.props.row;
        var editor = this.col.editor;
        this.prevalue = rowdata[field];
      },
      onEditorBlur(a, b, c, d){
        var field = this.getModelField();
        var rowdata = this.props.row;
        var editor = this.col.editor;
        if (editor.localselect || editor.remoteselect) {
          if (this.prevalue == rowdata[field] || editor.multiple) {
            this.stillshow = true;
          }
        }
        if (editor.number) {
          this.stillshow = true;
        }
      },
      renderSel(){
        var field = this.getModelField();
        var rowdata = this.props.row;
        var editor = this.col.editor;
        if (editor.localselect) {
          var valarr = editor.multiple ? rowdata[field] : [rowdata[field]];
          this.removeEmptyField(valarr);
          if (valarr.length > 0) {
            var strarr = [];
            for (var i = 0; i < valarr.length; i++) {
              var obj = valarr[i];
              var localdata = this.findArrayItem(editor.data, obj, editor.valueField);
              if (localdata) {
                strarr.push(localdata.data[editor.displayField]);
              }
            }
            return strarr.join(';');
          } else {
            return rowdata[field] || "请选择";
          }
        }
        if (editor.remoteselect) {
          var valarr = editor.multiple ? rowdata[field] : [rowdata[field]];
          this.removeEmptyField(valarr);
          if (valarr.length > 0) {
            var strarr = [];
            for (var i = 0; i < valarr.length; i++) {
              var obj = valarr[i];
              var localdata = this.findArrayItem(rowdata[editor.datafield], obj, editor.valueField);
              if (localdata) {
                strarr.push(localdata.data[editor.displayField]);
              }
            }
            return strarr.join(';');
          } else {
            return rowdata[field] || "请选择";
          }
        }
      },
      onAfterEdit(field, row, scope, ev){
        var a = 3;
        this.refreshPrevalue();
        this.editing = false;
        this.stillshow = false;
        this.syncValue();//select型watch慢一步所以需要手动同步
        this.$emit('change', this.col.field, this.props.row, this.props, ev);
      },
      syncValue(){
        var row = this.props.row;
        var editor = this.col.editor;
        var editpath = editor.editpath;
        var modelfield = this.getModelField();
        if (editpath) {
          this.setVueFieldVal(this.props.row, editpath, row[this.modelfield]);
        }
      },
      isMultiple(){
        return this.col.editor.multiple ? 'multiple' : null;
      },
      getRemoteSelectSearchMethod(row){
        var that = this;
        return function (query) {
          that.col.editor.remote(that.col.editor, that.props, query);
        }
      }
    },
    computed: {
      // 计算属性的 getter
      widthname: function () {
        // `this` 指向 vm 实例
        return this.col.flex ? 'min-width' : 'width';
      }
    }
  }
</script>
<style>
  .el-table__row .cell .el-card.is-always-shadow {
    width: fit-content;
    height: fit-content;
  }

  .el-table__row .cell .el-button + .el-button {
    margin-top: 5px;
    margin-bottom: 5px;
  }

  .el-table__row .cell .el-upload-list__item.is-success {
    display: none;
  }

  .el-table__row .cell .el-card.is-always-shadow .el-card__body {
    padding: 0;
    line-height: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/MyCellEditor.vue